import { ThemeUICSSObject } from 'theme-ui';

export enum BUTTON_VARIANTS {
  primary = 'primary',
  green = 'green',
  outlined = 'outlined',
}

export enum HIGHLIGHT_BUTTON_VARIANTS {
  blue = 'blue',
  yellow = 'yellow',
  pink = 'pink',
}

export const defaultButtonStyles: ThemeUICSSObject = {
  transition: 'all 0.1s ease-in-out',
  border: '1px solid transparent',
  outline: 'none',
  ':hover:not(:active, :disabled)': {
    boxShadow: 'md',
  },
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  gap: 3,
  borderRadius: 'full',
  fontWeight: 'medium',
  padding: 0,
  paddingY: 2,
  paddingX: 5,
  boxShadow: 'xs',
  fontFamily: 'body',
};

export const buttons: Record<BUTTON_VARIANTS, ThemeUICSSObject> = {
  [BUTTON_VARIANTS.primary]: {
    ...defaultButtonStyles,
    color: 'background',
    background: 'primary',
    ':active:not(:disabled)': {
      boxShadow: 'none',
      background: 'blueScale.4',
    },
    ':focus': {
      boxShadow: 'focus.primary',
      borderColor: 'blueScale.4',
    },

    ':disabled': { opacity: 0.5, boxShadow: 'none' },
  },
  [BUTTON_VARIANTS.green]: {
    ...defaultButtonStyles,
    color: 'greenScale.4',
    background: 'greenScale.3',
    ':active:not(:disabled)': {
      boxShadow: 'none',
      color: 'background',
      background: 'greenScale.4',
    },
    ':focus': {
      boxShadow: 'focus.primary',
      borderColor: 'greenScale.4',
    },
    ':disabled': { opacity: 0.5, boxShadow: 'none' },
  },
  [BUTTON_VARIANTS.outlined]: {
    ...defaultButtonStyles,
    color: 'primary',
    background: 'background',
    borderColor: 'primary',
    ':active:not(:disabled)': {
      boxShadow: 'none',
      background: 'blueScale.1',
    },
    ':focus': {
      boxShadow: 'focus.primary',
      outlineColor: 'primary',
    },
    ':disabled': { opacity: 0.5, boxShadow: 'none' },
  },
};

const defaultIconButtonStyles = {
  ...defaultButtonStyles,
  aspectRatio: '1/1',
  height: 'full',
};

export const iconButtons: Record<BUTTON_VARIANTS, ThemeUICSSObject> = {
  [BUTTON_VARIANTS.primary]: {
    ...defaultIconButtonStyles,
    color: 'background',
    background: 'primary',
    aspectRatio: '1/1',
    flexShrink: 0,
    ':active:not(:disabled)': {
      boxShadow: 'none',
      background: 'blueScale.4',
    },
    ':focus': {
      boxShadow: 'focus.primary',
      borderColor: 'blueScale.4',
    },
    ':disabled': { opacity: 0.5, boxShadow: 'none' },
  },
  [BUTTON_VARIANTS.green]: {
    ...defaultIconButtonStyles,
    color: 'greenScale.4',
    background: 'greenScale.3',
    ':active:not(:disabled)': {
      boxShadow: 'none',
      color: 'background',
      background: 'greenScale.4',
    },
    ':focus': {
      boxShadow: 'focus.primary',
      borderColor: 'greenScale.4',
    },
    ':disabled': { opacity: 0.5, boxShadow: 'none' },
  },
  [BUTTON_VARIANTS.outlined]: {
    ...defaultIconButtonStyles,
    color: 'primary',
    background: 'background',
    borderColor: 'primary',
    ':active:not(:disabled)': {
      boxShadow: 'none',
      background: 'blueScale.1',
    },
    ':focus': {
      boxShadow: 'focus.primary',
      outlineColor: 'primary',
    },
    ':disabled': { opacity: 0.5, boxShadow: 'none' },
  },
};
